<template>
  <van-skeleton title title-width="100%" :row="0" id="skeleton-banner" :loading="sloading">
    <van-swipe id="banner" class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in bannerList" :key="item.id">
        <van-image
          width="100%"
          height="100%"
          :src="item.img"
        />
      </van-swipe-item>
      <!-- <van-swipe-item>
        <van-image
          width="100%"
          src="/static/img/banner02.png"
        />
      </van-swipe-item>
      <van-swipe-item>
        <van-image
          width="100%"
          src="/static/img/banner03.png"
        />
      </van-swipe-item> -->
    </van-swipe>
  </van-skeleton>

</template>

<script>
const axios = require('axios')

export default {
  data () {
    return {
      bannerList: null,
      // imgUrl: 'https://www.sjzeis.com'
      sloading: true
    }
  },
  mounted () {
    let that = this
    // 获取banner
    axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=index')
      .then(function (response) {
        if (response.data.success && response.data.data.length > 0) {
          that.bannerList = response.data.data
          for (var index in that.bannerList) {
            let item = that.bannerList[index]
            item.img = that.global.apiUrl + '/file/getImgStream?idFile=' + item.idFile
            // console.log(item)
          }
          // console.log(that.bannerList)
          that.sloading = false
        }
      }).catch(function (error) { // 请求失败处理
        console.log(error)
      })
  },
  methods: {
    // get_bannerlist () {
    //   let that = this
    //   axios.get(that.global.apiUrl + '/web/banner/queryAllByType?type=index')
    //     .then(response => {
    //       // console.log(response);
    //       this.bannerList = response.data
    //       for (var index in this.bannerList) {
    //         let item = this.bannerList[index]
    //         item.img = that.global.apiUrl + '/file/getImgStream?idFile=' + item.idFile
    //         // console.log(item)
    //       }
    //     }).catch(error => {
    //       console.log(error.response)
    //     })
    // }
  }
}
</script>

<style>
#banner {
  height: 12rem;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/banner/banner.vue